import { PopUpComponent } from '../../components/PopUpComponent';
import { ILayoutProvider } from '../LayoutContext';

interface IEnableLocationModal {
  layoutService: ILayoutProvider;
}

export const EnableLocationModal = (props: IEnableLocationModal) => {
  const { layoutService } = props;

  const bodyModal = () => {
    return (
      <div className="p-4">
        <div className="py-8">
          Algunas funciones de la aplicación necesitan acceso a tu ubicación
          para funcionar correctamente. Por favor, activa la ubicación y permite
          el acceso para continuar.
        </div>
        {layoutService.showGuideToEnableLocation && (
          <div className="w-full mx-auto p-4">
            <h2 className="text-xl font-semibold text-center mb-4">
              Cómo activar la ubicación
            </h2>

            <div className="grid grid-cols-2 gap-6">
              {/* Edge */}
              <div className="p-4 border rounded-lg ">
                <span className="font-medium">Microsoft Edge</span>
                <ul className="list-disc list-inside text-sm mt-2">
                  <li>Haz clic en el candado en la barra de direcciones.</li>
                  <li>Haz clic en permisos de este sitio.</li>
                  <li>
                    Busca <strong>Ubicación</strong> y selecciona{' '}
                    <strong>Permitir</strong>.
                  </li>
                  <li>
                    Si no aparece, ve a *Configuración → Privacidad y seguridad
                    → Permisos del sitio*.
                  </li>
                  <li>Recarga la página.</li>
                </ul>
              </div>

              {/* Chrome */}
              <div className="p-4 border rounded-lg ">
                <span className="font-medium">Google Chrome</span>
                <ul className="list-disc list-inside text-sm mt-2">
                  <li>
                    En la barra de direcciones, a la izquierda del URL, haz clic
                    en el ícono de ajustes del sitio ( dos deslizadores)
                  </li>
                  <li>
                    Busca <strong>Ubicación</strong> y selecciona{' '}
                    <strong>Permitir</strong>.
                  </li>
                  <li>
                    Si no aparece, ve a `chrome://settings/content/location`.
                  </li>
                  <li>Recarga la página.</li>
                </ul>
              </div>

              {/* Firefox */}
              <div className="p-4 border rounded-lg ">
                <span className="font-medium">Mozilla Firefox</span>
                <ul className="list-disc list-inside text-sm mt-2">
                  <li>Haz clic en el icono de ubicación.</li>
                  <li>
                    Busca <strong>Ubicación</strong> y selecciona{' '}
                    <strong>Permitir</strong>.
                  </li>
                  <li>Recarga la página.</li>
                </ul>
              </div>

              {/* Safari */}
              <div className="p-4 border rounded-lg ">
                <span className="font-medium">Safari</span>
                <ul className="list-disc list-inside text-sm mt-2">
                  <li>En iPhone: Ve a *Configuración → Safari → Ubicación*.</li>
                  <li>En Mac: Ve a *Safari → Preferencias → Privacidad*.</li>
                  <li>
                    Cambia la opción a <strong>Permitir</strong> o{' '}
                    <strong>Preguntar</strong>.
                  </li>
                  <li>Recarga la página.</li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <PopUpComponent
      showPopUp={layoutService.showEnableLocationModal}
      header="Permitir acceso a tu ubicación"
      onClosePopUp={layoutService.openCloseLocationModal}
      body={bodyModal()}
    />
  );
};
